import type { MobileCountryCode } from "@/src_new/shared/redux/reducers/mobileCountryCodeSlice";

export const DEFAULT_MOBILE_COUNTRY_CODE = "91";

export const MOBILE_COUNTRY_CODES: MobileCountryCode[] = [
  {
    id: 6,
    country_code: "AD",
    mobile_country_code: "+376",
    regex_pattern: "^\\+376[ \\-]?[346]\\d{5}$",
  },
  { id: 233, country_code: "AE", mobile_country_code: "+971", regex_pattern: "^\\+971\\d{9}$" },
  { id: 1, country_code: "AF", mobile_country_code: "+93", regex_pattern: "^\\+93[ \\-]?7\\d{8}$" },
  { id: 10, country_code: "AG", mobile_country_code: "+1-268", regex_pattern: "^\\+1-268\\d{7}$" },
  { id: 8, country_code: "AI", mobile_country_code: "+1-264", regex_pattern: "^\\+1-264\\d{7}$" },
  {
    id: 3,
    country_code: "AL",
    mobile_country_code: "+355",
    regex_pattern: "^\\+355[ \\-]?6\\d{8}$",
  },
  {
    id: 12,
    country_code: "AM",
    mobile_country_code: "+374",
    regex_pattern: "^\\+374[ \\-]?[34579]\\d{7}$",
  },
  { id: 155, country_code: "AN", mobile_country_code: "+599", regex_pattern: "^\\+599\\d{6,7}$" },
  {
    id: 7,
    country_code: "AO",
    mobile_country_code: "+244",
    regex_pattern: "^\\+244[ \\-]?9\\d{8}$",
  },
  { id: 9, country_code: "AQ", mobile_country_code: "+672", regex_pattern: "^\\+672\\d{6,7}$" },
  {
    id: 11,
    country_code: "AR",
    mobile_country_code: "+54",
    regex_pattern: "^\\+54[ \\-]?\\d{2,4}15\\d{6,7}$",
  },
  { id: 5, country_code: "AS", mobile_country_code: "+1-684", regex_pattern: "^\\+1-684\\d{7}$" },
  {
    id: 15,
    country_code: "AT",
    mobile_country_code: "+43",
    regex_pattern: "^\\+43[ \\-]?6\\d{9,12}$",
  },
  {
    id: 14,
    country_code: "AU",
    mobile_country_code: "+61",
    regex_pattern: "^\\+61[ \\-]?4\\d{8}$",
  },
  {
    id: 13,
    country_code: "AW",
    mobile_country_code: "+297",
    regex_pattern: "^\\+297[ \\-]?[567]\\d{6}$",
  },
  { id: 2, country_code: "AX", mobile_country_code: "+358", regex_pattern: "^\\+358\\d{7,10}$" },
  { id: 16, country_code: "AZ", mobile_country_code: "+994", regex_pattern: "^\\+994\\d{9}$" },
  { id: 28, country_code: "BA", mobile_country_code: "+387", regex_pattern: "^\\+387\\d{8,9}$" },
  { id: 20, country_code: "BB", mobile_country_code: "+1-246", regex_pattern: "^\\+1-246\\d{7}$" },
  { id: 19, country_code: "BD", mobile_country_code: "+880", regex_pattern: "^\\+880\\d{10}$" },
  { id: 22, country_code: "BE", mobile_country_code: "+32", regex_pattern: "^\\+32\\d{9}$" },
  { id: 35, country_code: "BF", mobile_country_code: "+226", regex_pattern: "^\\+226\\d{8}$" },
  { id: 34, country_code: "BG", mobile_country_code: "+359", regex_pattern: "^\\+359\\d{8,9}$" },
  { id: 18, country_code: "BH", mobile_country_code: "+973", regex_pattern: "^\\+973\\d{8}$" },
  { id: 36, country_code: "BI", mobile_country_code: "+257", regex_pattern: "^\\+257\\d{8}$" },
  { id: 24, country_code: "BJ", mobile_country_code: "+229", regex_pattern: "^\\+229\\d{8}$" },
  { id: 184, country_code: "BL", mobile_country_code: "+590", regex_pattern: "^\\+590\\d{9}$" },
  { id: 25, country_code: "BM", mobile_country_code: "+1-441", regex_pattern: "^\\+1-441\\d{7}$" },
  { id: 33, country_code: "BN", mobile_country_code: "+673", regex_pattern: "^\\+673\\d{7}$" },
  { id: 27, country_code: "BO", mobile_country_code: "+591", regex_pattern: "^\\+591\\d{8}$" },
  { id: 31, country_code: "BR", mobile_country_code: "+55", regex_pattern: "^\\+55\\d{10,11}$" },
  { id: 17, country_code: "BS", mobile_country_code: "+1-242", regex_pattern: "^\\+1-242\\d{7}$" },
  { id: 26, country_code: "BT", mobile_country_code: "+975", regex_pattern: "^\\+975\\d{7}$" },
  { id: 30, country_code: "BV", mobile_country_code: "+47", regex_pattern: "^\\+47\\d{8}$" },
  { id: 29, country_code: "BW", mobile_country_code: "+267", regex_pattern: "^\\+267\\d{8}$" },
  { id: 21, country_code: "BY", mobile_country_code: "+375", regex_pattern: "^\\+375\\d{9}$" },
  { id: 23, country_code: "BZ", mobile_country_code: "+501", regex_pattern: "^\\+501\\d{7}$" },
  { id: 39, country_code: "CA", mobile_country_code: "+1", regex_pattern: "^\\+1\\d{10}$" },
  {
    id: 47,
    country_code: "CC",
    mobile_country_code: "+61",
    regex_pattern: "^\\+61[ \\-]?4\\d{8}$",
  },
  { id: 51, country_code: "CD", mobile_country_code: "+243", regex_pattern: "^\\+243\\d{9}$" },
  {
    id: 42,
    country_code: "CF",
    mobile_country_code: "+236",
    regex_pattern: "^\\+236[ \\-]?\\d{8}$",
  },
  {
    id: 50,
    country_code: "CG",
    mobile_country_code: "+242",
    regex_pattern: "^\\+242[ \\-]?\\d{9}$",
  },
  { id: 215, country_code: "CH", mobile_country_code: "+41", regex_pattern: "^\\+41\\d{9}$" },
  {
    id: 54,
    country_code: "CI",
    mobile_country_code: "+225",
    regex_pattern: "^\\+225[ \\-]?\\d{10}$",
  },
  {
    id: 52,
    country_code: "CK",
    mobile_country_code: "+682",
    regex_pattern: "^\\+682[ \\-]?\\d{5}$",
  },
  {
    id: 44,
    country_code: "CL",
    mobile_country_code: "+56",
    regex_pattern: "^\\+56[ \\-]?9\\d{8}$",
  },
  { id: 38, country_code: "CM", mobile_country_code: "+237", regex_pattern: "^\\+237\\d{9}$" },
  { id: 45, country_code: "CN", mobile_country_code: "+86", regex_pattern: "^\\+86\\d{11}$" },
  {
    id: 48,
    country_code: "CO",
    mobile_country_code: "+57",
    regex_pattern: "^\\+57[ \\-]?3\\d{9}$",
  },
  {
    id: 53,
    country_code: "CR",
    mobile_country_code: "+506",
    regex_pattern: "^\\+506[ \\-]?[678]\\d{7}$",
  },
  {
    id: 56,
    country_code: "CU",
    mobile_country_code: "+53",
    regex_pattern: "^\\+53[ \\-]?[56]\\d{7}$",
  },
  {
    id: 40,
    country_code: "CV",
    mobile_country_code: "+238",
    regex_pattern: "^\\+238[ \\-]?9\\d{6}$",
  },
  {
    id: 46,
    country_code: "CX",
    mobile_country_code: "+61",
    regex_pattern: "^\\+61[ \\-]?4\\d{8}$",
  },
  { id: 57, country_code: "CY", mobile_country_code: "+357", regex_pattern: "^\\+357\\d{8}$" },
  { id: 58, country_code: "CZ", mobile_country_code: "+420", regex_pattern: "^\\+420\\d{9}$" },
  {
    id: 81,
    country_code: "DE",
    mobile_country_code: "+49",
    regex_pattern: "^\\+49[ \\-]?1[5-7]\\d{8,9}$",
  },
  { id: 60, country_code: "DJ", mobile_country_code: "+253", regex_pattern: "^\\+253\\d{8}$" },
  { id: 59, country_code: "DK", mobile_country_code: "+45", regex_pattern: "^\\+45\\d{8}$" },
  { id: 61, country_code: "DM", mobile_country_code: "+1-767", regex_pattern: "^\\+1-767\\d{7}$" },
  { id: 62, country_code: "DO", mobile_country_code: "+1-809", regex_pattern: "^\\+1-809\\d{7}$" },
  {
    id: 4,
    country_code: "DZ",
    mobile_country_code: "+213",
    regex_pattern: "^\\+213[ \\-]?[567]\\d{8}$",
  },
  { id: 63, country_code: "EC", mobile_country_code: "+593", regex_pattern: "^\\+593\\d{9}$" },
  { id: 68, country_code: "EE", mobile_country_code: "+372", regex_pattern: "^\\+372\\d{7,8}$" },
  { id: 64, country_code: "EG", mobile_country_code: "+20", regex_pattern: "^\\+20\\d{9,10}$" },
  { id: 245, country_code: "EH", mobile_country_code: "+212", regex_pattern: "^\\+212\\d{9}$" },
  { id: 67, country_code: "ER", mobile_country_code: "+291", regex_pattern: "^\\+291\\d{6,7}$" },
  { id: 208, country_code: "ES", mobile_country_code: "+34", regex_pattern: "^\\+34\\d{9}$" },
  { id: 69, country_code: "ET", mobile_country_code: "+251", regex_pattern: "^\\+251\\d{9}$" },
  { id: 73, country_code: "FI", mobile_country_code: "+358", regex_pattern: "^\\+358\\d{7,10}$" },
  { id: 72, country_code: "FJ", mobile_country_code: "+679", regex_pattern: "^\\+679\\d{7}$" },
  { id: 70, country_code: "FK", mobile_country_code: "+500", regex_pattern: "^\\+500\\d{5}$" },
  { id: 142, country_code: "FM", mobile_country_code: "+691", regex_pattern: "^\\+691\\d{7}$" },
  { id: 71, country_code: "FO", mobile_country_code: "+298", regex_pattern: "^\\+298\\d{6}$" },
  { id: 74, country_code: "FR", mobile_country_code: "+33", regex_pattern: "^\\+33\\d{9}$" },
  {
    id: 78,
    country_code: "GA",
    mobile_country_code: "+241",
    regex_pattern: "^\\+241[ \\-]?\\d{7,8}$",
  },
  { id: 234, country_code: "GB", mobile_country_code: "+44", regex_pattern: "^\\+44\\d{10}$" },
  { id: 86, country_code: "GD", mobile_country_code: "+1-473", regex_pattern: "^\\+1-473\\d{7}$" },
  {
    id: 80,
    country_code: "GE",
    mobile_country_code: "+995",
    regex_pattern: "^\\+995[ \\-]?5\\d{8}$",
  },
  { id: 75, country_code: "GF", mobile_country_code: "+594", regex_pattern: "^\\+594\\d{9}$" },
  { id: 90, country_code: "GG", mobile_country_code: "+44", regex_pattern: "^\\+44\\d{10}$" },
  {
    id: 82,
    country_code: "GH",
    mobile_country_code: "+233",
    regex_pattern: "^\\+233[ \\-]?[25]\\d{8}$",
  },
  {
    id: 83,
    country_code: "GI",
    mobile_country_code: "+350",
    regex_pattern: "^\\+350[ \\-]?[56]\\d{7}$",
  },
  { id: 85, country_code: "GL", mobile_country_code: "+299", regex_pattern: "^\\+299\\d{6}$" },
  {
    id: 79,
    country_code: "GM",
    mobile_country_code: "+220",
    regex_pattern: "^\\+220[ \\-]?\\d{7}$",
  },
  { id: 91, country_code: "GN", mobile_country_code: "+224", regex_pattern: "^\\+224\\d{9}$" },
  { id: 87, country_code: "GP", mobile_country_code: "+590", regex_pattern: "^\\+590\\d{9}$" },
  { id: 66, country_code: "GQ", mobile_country_code: "+240", regex_pattern: "^\\+240\\d{6}$" },
  {
    id: 84,
    country_code: "GR",
    mobile_country_code: "+30",
    regex_pattern: "^\\+30[ \\-]?6\\d{9}$",
  },
  { id: 205, country_code: "GS", mobile_country_code: "+500", regex_pattern: "^\\+500\\d{5}$" },
  { id: 89, country_code: "GT", mobile_country_code: "+502", regex_pattern: "^\\+502\\d{8}$" },
  { id: 88, country_code: "GU", mobile_country_code: "+1-671", regex_pattern: "^\\+1-671\\d{7}$" },
  { id: 92, country_code: "GW", mobile_country_code: "+245", regex_pattern: "^\\+245\\d{7}$" },
  { id: 93, country_code: "GY", mobile_country_code: "+592", regex_pattern: "^\\+592\\d{7}$" },
  { id: 98, country_code: "HK", mobile_country_code: "+852", regex_pattern: "^\\+852\\d{8}$" },
  {
    id: 95,
    country_code: "HM",
    mobile_country_code: "+61",
    regex_pattern: "^\\+61[ \\-]?4\\d{8}$",
  },
  { id: 97, country_code: "HN", mobile_country_code: "+504", regex_pattern: "^\\+504\\d{8}$" },
  { id: 55, country_code: "HR", mobile_country_code: "+385", regex_pattern: "^\\+385\\d{8,9}$" },
  { id: 94, country_code: "HT", mobile_country_code: "+509", regex_pattern: "^\\+509\\d{8}$" },
  { id: 99, country_code: "HU", mobile_country_code: "+36", regex_pattern: "^\\+36\\d{8,9}$" },
  { id: 102, country_code: "ID", mobile_country_code: "+62", regex_pattern: "^\\+62\\d{9,12}$" },
  { id: 104, country_code: "IE", mobile_country_code: "+353", regex_pattern: "^\\+353\\d{9}$" },
  { id: 107, country_code: "IL", mobile_country_code: "+972", regex_pattern: "^\\+972\\d{8,9}$" },
  { id: 106, country_code: "IM", mobile_country_code: "+44", regex_pattern: "^\\+44\\d{10}$" },
  { id: 101, country_code: "IN", mobile_country_code: "+91", regex_pattern: "^\\+91\\d{10}$" },
  { id: 32, country_code: "IO", mobile_country_code: "+246", regex_pattern: "^\\+246\\d{7}$" },
  { id: 103, country_code: "IQ", mobile_country_code: "+964", regex_pattern: "^\\+964\\d{9,10}$" },
  {
    id: 105,
    country_code: "IR",
    mobile_country_code: "+98",
    regex_pattern: "^\\+98[ \\-]?9\\d{9}$",
  },
  { id: 100, country_code: "IS", mobile_country_code: "+354", regex_pattern: "^\\+354\\d{7}$" },
  { id: 108, country_code: "IT", mobile_country_code: "+39", regex_pattern: "^\\+39\\d{9,10}$" },
  { id: 111, country_code: "JE", mobile_country_code: "+44", regex_pattern: "^\\+44\\d{10}$" },
  { id: 109, country_code: "JM", mobile_country_code: "+1-876", regex_pattern: "^\\+1-876\\d{7}$" },
  { id: 112, country_code: "JO", mobile_country_code: "+962", regex_pattern: "^\\+962\\d{9}$" },
  { id: 110, country_code: "JP", mobile_country_code: "+81", regex_pattern: "^\\+81\\d{9,10}$" },
  { id: 114, country_code: "KE", mobile_country_code: "+254", regex_pattern: "^\\+254\\d{9}$" },
  {
    id: 118,
    country_code: "KG",
    mobile_country_code: "+996",
    regex_pattern: "^\\+996[ \\-]?\\d{9}$",
  },
  {
    id: 37,
    country_code: "KH",
    mobile_country_code: "+855",
    regex_pattern: "^\\+855[ \\-]?\\d{8,9}$",
  },
  {
    id: 115,
    country_code: "KI",
    mobile_country_code: "+686",
    regex_pattern: "^\\+686[ \\-]?7\\d{7}$",
  },
  {
    id: 49,
    country_code: "KM",
    mobile_country_code: "+269",
    regex_pattern: "^\\+269[ \\-]?3\\d{6}$",
  },
  { id: 186, country_code: "KN", mobile_country_code: "+1-869", regex_pattern: "^\\+1-869\\d{7}$" },
  { id: 164, country_code: "KP", mobile_country_code: "+850", regex_pattern: "^\\+850\\d{8,9}$" },
  { id: 206, country_code: "KR", mobile_country_code: "+82", regex_pattern: "^\\+82\\d{9,10}$" },
  {
    id: 117,
    country_code: "KW",
    mobile_country_code: "+965",
    regex_pattern: "^\\+965[ \\-]?[4569]\\d{7}$",
  },
  { id: 41, country_code: "KY", mobile_country_code: "+1-345", regex_pattern: "^\\+1-345\\d{7}$" },
  {
    id: 113,
    country_code: "KZ",
    mobile_country_code: "+7",
    regex_pattern: "^\\+7[ \\-]?[79]\\d{9}$",
  },
  {
    id: 119,
    country_code: "LA",
    mobile_country_code: "+856",
    regex_pattern: "^\\+856[ \\-]?20\\d{8}$",
  },
  {
    id: 121,
    country_code: "LB",
    mobile_country_code: "+961",
    regex_pattern: "^\\+961[ \\-]?(3\\d{6}|(70|71|76|78|79|81)\\d{6})$",
  },
  { id: 187, country_code: "LC", mobile_country_code: "+1-758", regex_pattern: "^\\+1-758\\d{7}$" },
  {
    id: 125,
    country_code: "LI",
    mobile_country_code: "+423",
    regex_pattern: "^\\+423[ \\-]?7\\d{6}$",
  },
  {
    id: 209,
    country_code: "LK",
    mobile_country_code: "+94",
    regex_pattern: "^\\+94[ \\-]?7\\d{8}$",
  },
  {
    id: 123,
    country_code: "LR",
    mobile_country_code: "+231",
    regex_pattern: "^\\+231[ \\-]?\\d{7,8}$",
  },
  {
    id: 122,
    country_code: "LS",
    mobile_country_code: "+266",
    regex_pattern: "^\\+266[ \\-]?[56]\\d{7}$",
  },
  {
    id: 126,
    country_code: "LT",
    mobile_country_code: "+370",
    regex_pattern: "^\\+370[ \\-]?6\\d{7}$",
  },
  {
    id: 127,
    country_code: "LU",
    mobile_country_code: "+352",
    regex_pattern: "^\\+352[ \\-]?6\\d{8}$",
  },
  {
    id: 120,
    country_code: "LV",
    mobile_country_code: "+371",
    regex_pattern: "^\\+371[ \\-]?2\\d{7}$",
  },
  {
    id: 124,
    country_code: "LY",
    mobile_country_code: "+218",
    regex_pattern: "^\\+218[ \\-]?9\\d{8}$",
  },
  { id: 148, country_code: "MA", mobile_country_code: "+212", regex_pattern: "^\\+212\\d{9}$" },
  { id: 144, country_code: "MC", mobile_country_code: "+377", regex_pattern: "^\\+377\\d{8,9}$" },
  { id: 143, country_code: "MD", mobile_country_code: "+373", regex_pattern: "^\\+373\\d{8}$" },
  { id: 146, country_code: "ME", mobile_country_code: "+382", regex_pattern: "^\\+382\\d{8,9}$" },
  { id: 188, country_code: "MF", mobile_country_code: "+590", regex_pattern: "^\\+590\\d{9}$" },
  {
    id: 130,
    country_code: "MG",
    mobile_country_code: "+261",
    regex_pattern: "^\\+261[ \\-]?3\\d{8}$",
  },
  {
    id: 136,
    country_code: "MH",
    mobile_country_code: "+692",
    regex_pattern: "^\\+692[ \\-]?\\d{7}$",
  },
  {
    id: 129,
    country_code: "MK",
    mobile_country_code: "+389",
    regex_pattern: "^\\+389[ \\-]?7\\d{7}$",
  },
  {
    id: 134,
    country_code: "ML",
    mobile_country_code: "+223",
    regex_pattern: "^\\+223[ \\-]?[5-8]\\d{7}$",
  },
  { id: 150, country_code: "MM", mobile_country_code: "+95", regex_pattern: "^\\+95\\d{7,9}$" },
  { id: 145, country_code: "MN", mobile_country_code: "+976", regex_pattern: "^\\+976\\d{8}$" },
  {
    id: 128,
    country_code: "MO",
    mobile_country_code: "+853",
    regex_pattern: "^\\+853[ \\-]?6\\d{7}$",
  },
  { id: 163, country_code: "MP", mobile_country_code: "+1-670", regex_pattern: "^\\+1-670\\d{7}$" },
  {
    id: 137,
    country_code: "MQ",
    mobile_country_code: "+596",
    regex_pattern: "^\\+596[ \\-]?6\\d{8}$",
  },
  {
    id: 138,
    country_code: "MR",
    mobile_country_code: "+222",
    regex_pattern: "^\\+222[ \\-]?[234]\\d{7}$",
  },
  { id: 147, country_code: "MS", mobile_country_code: "+1-664", regex_pattern: "^\\+1-664\\d{7}$" },
  {
    id: 135,
    country_code: "MT",
    mobile_country_code: "+356",
    regex_pattern: "^\\+356[ \\-]?[79]\\d{7}$",
  },
  { id: 139, country_code: "MU", mobile_country_code: "+230", regex_pattern: "^\\+230\\d{7,8}$" },
  {
    id: 133,
    country_code: "MV",
    mobile_country_code: "+960",
    regex_pattern: "^\\+960[ \\-]?[79]\\d{6}$",
  },
  {
    id: 131,
    country_code: "MW",
    mobile_country_code: "+265",
    regex_pattern: "^\\+265[ \\-]?[89]\\d{8}$",
  },
  { id: 141, country_code: "MX", mobile_country_code: "+52", regex_pattern: "^\\+52\\d{10}$" },
  {
    id: 132,
    country_code: "MY",
    mobile_country_code: "+60",
    regex_pattern: "^\\+60[ \\-]?1\\d{8,9}$",
  },
  { id: 149, country_code: "MZ", mobile_country_code: "+258", regex_pattern: "^\\+258\\d{8,9}$" },
  { id: 151, country_code: "NA", mobile_country_code: "+264", regex_pattern: "^\\+264\\d{9}$" },
  { id: 156, country_code: "NC", mobile_country_code: "+687", regex_pattern: "^\\+687\\d{6}$" },
  { id: 159, country_code: "NE", mobile_country_code: "+227", regex_pattern: "^\\+227\\d{8}$" },
  { id: 162, country_code: "NF", mobile_country_code: "+672", regex_pattern: "^\\+672\\d{6,7}$" },
  { id: 160, country_code: "NG", mobile_country_code: "+234", regex_pattern: "^\\+234\\d{10}$" },
  {
    id: 158,
    country_code: "NI",
    mobile_country_code: "+505",
    regex_pattern: "^\\+505[ \\-]?[578]\\d{7}$",
  },
  { id: 154, country_code: "NL", mobile_country_code: "+31", regex_pattern: "^\\+31\\d{9}$" },
  { id: 165, country_code: "NO", mobile_country_code: "+47", regex_pattern: "^\\+47\\d{8}$" },
  { id: 153, country_code: "NP", mobile_country_code: "+977", regex_pattern: "^\\+977\\d{9,10}$" },
  {
    id: 152,
    country_code: "NR",
    mobile_country_code: "+674",
    regex_pattern: "^\\+674[ \\-]?\\d{7}$",
  },
  { id: 161, country_code: "NU", mobile_country_code: "+683", regex_pattern: "^\\+683\\d{4}$" },
  { id: 157, country_code: "NZ", mobile_country_code: "+64", regex_pattern: "^\\+64\\d{7,9}$" },
  { id: 166, country_code: "OM", mobile_country_code: "+968", regex_pattern: "^\\+968\\d{8}$" },
  { id: 170, country_code: "PA", mobile_country_code: "+507", regex_pattern: "^\\+507\\d{7,8}$" },
  {
    id: 173,
    country_code: "PE",
    mobile_country_code: "+51",
    regex_pattern: "^\\+51[ \\-]?9\\d{8}$",
  },
  { id: 76, country_code: "PF", mobile_country_code: "+689", regex_pattern: "^\\+689\\d{8}$" },
  { id: 171, country_code: "PG", mobile_country_code: "+675", regex_pattern: "^\\+675\\d{8}$" },
  {
    id: 174,
    country_code: "PH",
    mobile_country_code: "+63",
    regex_pattern: "^\\+63[ \\-]?9\\d{9}$",
  },
  { id: 167, country_code: "PK", mobile_country_code: "+92", regex_pattern: "^\\+92\\d{10}$" },
  {
    id: 176,
    country_code: "PL",
    mobile_country_code: "+48",
    regex_pattern: "^\\+48[ \\-]?[4-8]\\d{8}$",
  },
  {
    id: 189,
    country_code: "PM",
    mobile_country_code: "+508",
    regex_pattern: "^\\+508[ \\-]?\\d{6}$",
  },
  { id: 175, country_code: "PN", mobile_country_code: "+64", regex_pattern: "^\\+64\\d{7,9}$" },
  { id: 178, country_code: "PR", mobile_country_code: "+1-787", regex_pattern: "^\\+1-787\\d{7}$" },
  { id: 169, country_code: "PS", mobile_country_code: "+970", regex_pattern: "^\\+970\\d{9}$" },
  {
    id: 177,
    country_code: "PT",
    mobile_country_code: "+351",
    regex_pattern: "^\\+351[ \\-]?9\\d{8}$",
  },
  { id: 168, country_code: "PW", mobile_country_code: "+680", regex_pattern: "^\\+680\\d{7}$" },
  {
    id: 172,
    country_code: "PY",
    mobile_country_code: "+595",
    regex_pattern: "^\\+595[ \\-]?9\\d{8}$",
  },
  {
    id: 179,
    country_code: "QA",
    mobile_country_code: "+974",
    regex_pattern: "^\\+974[ \\-]?[3567]\\d{7}$",
  },
  { id: 180, country_code: "RE", mobile_country_code: "+262", regex_pattern: "^\\+262\\d{9}$" },
  {
    id: 181,
    country_code: "RO",
    mobile_country_code: "+40",
    regex_pattern: "^\\+40[ \\-]?7\\d{8}$",
  },
  {
    id: 196,
    country_code: "RS",
    mobile_country_code: "+381",
    regex_pattern: "^\\+381[ \\-]?6\\d{8}$",
  },
  {
    id: 182,
    country_code: "RU",
    mobile_country_code: "+7",
    regex_pattern: "^\\+7[ \\-]?[79]\\d{9}$",
  },
  {
    id: 183,
    country_code: "RW",
    mobile_country_code: "+250",
    regex_pattern: "^\\+250[ \\-]?7\\d{8}$",
  },
  {
    id: 194,
    country_code: "SA",
    mobile_country_code: "+966",
    regex_pattern: "^\\+966[ \\-]?5\\d{8}$",
  },
  { id: 202, country_code: "SB", mobile_country_code: "+677", regex_pattern: "^\\+677\\d{5,7}$" },
  { id: 197, country_code: "SC", mobile_country_code: "+248", regex_pattern: "^\\+248\\d{6,7}$" },
  { id: 210, country_code: "SD", mobile_country_code: "+249", regex_pattern: "^\\+249\\d{9}$" },
  { id: 214, country_code: "SE", mobile_country_code: "+46", regex_pattern: "^\\+46\\d{9}$" },
  { id: 199, country_code: "SG", mobile_country_code: "+65", regex_pattern: "^\\+65[689]\\d{7}$" },
  {
    id: 185,
    country_code: "SH",
    mobile_country_code: "+290",
    regex_pattern: "^\\+290[ \\-]?\\d{5}$",
  },
  { id: 201, country_code: "SI", mobile_country_code: "+386", regex_pattern: "^\\+386\\d{8,9}$" },
  { id: 212, country_code: "SJ", mobile_country_code: "+47", regex_pattern: "^\\+47\\d{8}$" },
  { id: 200, country_code: "SK", mobile_country_code: "+421", regex_pattern: "^\\+421\\d{9}$" },
  { id: 198, country_code: "SL", mobile_country_code: "+232", regex_pattern: "^\\+232\\d{8,9}$" },
  {
    id: 192,
    country_code: "SM",
    mobile_country_code: "+378",
    regex_pattern: "^\\+378[ \\-]?3\\d{9}$",
  },
  {
    id: 195,
    country_code: "SN",
    mobile_country_code: "+221",
    regex_pattern: "^\\+221[ \\-]?7\\d{8}$",
  },
  { id: 203, country_code: "SO", mobile_country_code: "+252", regex_pattern: "^\\+252\\d{8,9}$" },
  {
    id: 211,
    country_code: "SR",
    mobile_country_code: "+597",
    regex_pattern: "^\\+597[ \\-]?[78]\\d{6}$",
  },
  { id: 207, country_code: "SS", mobile_country_code: "+211", regex_pattern: "^\\+211\\d{9}$" },
  {
    id: 193,
    country_code: "ST",
    mobile_country_code: "+239",
    regex_pattern: "^\\+239[ \\-]?9\\d{6}$",
  },
  { id: 65, country_code: "SV", mobile_country_code: "+503", regex_pattern: "^\\+503\\d{8}$" },
  { id: 216, country_code: "SY", mobile_country_code: "+963", regex_pattern: "^\\+963\\d{9}$" },
  { id: 213, country_code: "SZ", mobile_country_code: "+268", regex_pattern: "^\\+268\\d{8}$" },
  { id: 229, country_code: "TC", mobile_country_code: "+1-649", regex_pattern: "^\\+1-649\\d{7}$" },
  {
    id: 43,
    country_code: "TD",
    mobile_country_code: "+235",
    regex_pattern: "^\\+235[ \\-]?[679]\\d{7}$",
  },
  { id: 77, country_code: "TF", mobile_country_code: "+262", regex_pattern: "^\\+262\\d{9}$" },
  { id: 222, country_code: "TG", mobile_country_code: "+228", regex_pattern: "^\\+228\\d{8}$" },
  { id: 220, country_code: "TH", mobile_country_code: "+66", regex_pattern: "^\\+66\\d{9}$" },
  { id: 218, country_code: "TJ", mobile_country_code: "+992", regex_pattern: "^\\+992\\d{9}$" },
  { id: 223, country_code: "TK", mobile_country_code: "+690", regex_pattern: "^\\+690\\d{4}$" },
  { id: 221, country_code: "TL", mobile_country_code: "+670", regex_pattern: "^\\+670\\d{7}$" },
  { id: 228, country_code: "TM", mobile_country_code: "+993", regex_pattern: "^\\+993\\d{8}$" },
  { id: 226, country_code: "TN", mobile_country_code: "+216", regex_pattern: "^\\+216\\d{8}$" },
  { id: 224, country_code: "TO", mobile_country_code: "+676", regex_pattern: "^\\+676\\d{5}$" },
  { id: 227, country_code: "TR", mobile_country_code: "+90", regex_pattern: "^\\+90\\d{10}$" },
  { id: 225, country_code: "TT", mobile_country_code: "+1-868", regex_pattern: "^\\+1-868\\d{7}$" },
  { id: 230, country_code: "TV", mobile_country_code: "+688", regex_pattern: "^\\+688\\d{5}$" },
  { id: 217, country_code: "TW", mobile_country_code: "+886", regex_pattern: "^\\+886\\d{9}$" },
  { id: 219, country_code: "TZ", mobile_country_code: "+255", regex_pattern: "^\\+255\\d{9}$" },
  { id: 232, country_code: "UA", mobile_country_code: "+380", regex_pattern: "^\\+380\\d{9}$" },
  { id: 231, country_code: "UG", mobile_country_code: "+256", regex_pattern: "^\\+256\\d{9}$" },
  { id: 236, country_code: "UM", mobile_country_code: "+1", regex_pattern: "^\\+1\\d{10}$" },
  { id: 235, country_code: "US", mobile_country_code: "+1", regex_pattern: "^\\+1\\d{10}$" },
  { id: 237, country_code: "UY", mobile_country_code: "+598", regex_pattern: "^\\+598\\d{8}$" },
  { id: 238, country_code: "UZ", mobile_country_code: "+998", regex_pattern: "^\\+998\\d{9}$" },
  { id: 96, country_code: "VA", mobile_country_code: "+379", regex_pattern: "^\\+379\\d{8}$" },
  { id: 190, country_code: "VC", mobile_country_code: "+1-784", regex_pattern: "^\\+1-784\\d{7}$" },
  { id: 240, country_code: "VE", mobile_country_code: "+58", regex_pattern: "^\\+58\\d{10}$" },
  { id: 242, country_code: "VG", mobile_country_code: "+1-284", regex_pattern: "^\\+1-284\\d{7}$" },
  { id: 243, country_code: "VI", mobile_country_code: "+1-340", regex_pattern: "^\\+1-340\\d{7}$" },
  { id: 241, country_code: "VN", mobile_country_code: "+84", regex_pattern: "^\\+84\\d{9}$" },
  { id: 239, country_code: "VU", mobile_country_code: "+678", regex_pattern: "^\\+678\\d{7}$" },
  { id: 244, country_code: "WF", mobile_country_code: "+681", regex_pattern: "^\\+681\\d{6}$" },
  {
    id: 191,
    country_code: "WS",
    mobile_country_code: "+685",
    regex_pattern: "^\\+685[ \\-]?7\\d{6}$",
  },
  {
    id: 116,
    country_code: "XK",
    mobile_country_code: "+383",
    regex_pattern: "^\\+383[ \\-]?4\\d{7}$",
  },
  { id: 246, country_code: "YE", mobile_country_code: "+967", regex_pattern: "^\\+967\\d{9}$" },
  { id: 140, country_code: "YT", mobile_country_code: "+262", regex_pattern: "^\\+262\\d{9}$" },
  {
    id: 247,
    country_code: "YU",
    mobile_country_code: "+381",
    regex_pattern: "^\\+381[ \\-]?6\\d{8}$",
  },
  { id: 204, country_code: "ZA", mobile_country_code: "+27", regex_pattern: "^\\+27\\d{9}$" },
  { id: 249, country_code: "ZM", mobile_country_code: "+260", regex_pattern: "^\\+260\\d{9}$" },
  { id: 248, country_code: "ZR", mobile_country_code: "+243", regex_pattern: "^\\+243\\d{9}$" },
  { id: 250, country_code: "ZW", mobile_country_code: "+263", regex_pattern: "^\\+263\\d{9}$" },
];

/** "+1-268" -> "1268", so codes coming from the API and the form stay comparable */
export const cleanMobileCountryCode = (value?: string) => String(value || "").replace(/\D/g, "");

export const findMobileCountry = (
  countryCode?: string,
  countryList: MobileCountryCode[] = MOBILE_COUNTRY_CODES
) => {
  const cleanCode = cleanMobileCountryCode(countryCode);

  return countryList.find(
    (country) => cleanMobileCountryCode(country.mobile_country_code) === cleanCode
  );
};

export const getDialCode = (
  countryCode?: string,
  countryList: MobileCountryCode[] = MOBILE_COUNTRY_CODES
) => {
  const country = findMobileCountry(countryCode, countryList) || findMobileCountry(countryCode);
  const dialCode = country?.mobile_country_code || cleanMobileCountryCode(countryCode);

  if (!dialCode) {
    return "";
  }

  return dialCode.startsWith("+") ? dialCode : `+${dialCode}`;
};

export const formatMobileNumber = (
  countryCode?: string,
  number?: string,
  countryList: MobileCountryCode[] = MOBILE_COUNTRY_CODES
) => {
  const localNumber = String(number ?? "").trim();

  if (!localNumber) {
    return "";
  }

  const dialCode = getDialCode(countryCode, countryList);

  return dialCode ? `${dialCode} ${localNumber}` : localNumber;
};

export const validateMobileNumber = (
  number: string,
  countryCode?: string,
  countryList: MobileCountryCode[] = MOBILE_COUNTRY_CODES
): true | string => {
  const country = findMobileCountry(countryCode, countryList) || findMobileCountry(countryCode);

  if (!country) {
    return "Invalid country code";
  }

  if (!country.regex_pattern) {
    return true;
  }

  return new RegExp(country.regex_pattern).test(`${getDialCode(countryCode, countryList)}${number}`)
    ? true
    : "Please enter a valid Phone Number";
};
